import React from "react";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Accordion from "../../../common/accordion";
import { LABELS } from "../../../../constants/labels/help.labels";

const WellSurvey: React.FC = () => {
    const { summaryCollapse } = useAppSelector((state) => state?.collapse);

    const { updateSummaryCollapse, updateGasSeparatorCollapse } =
        useCollapseFacade();

    const handleCollapseChange = (key: boolean, name: string) => {
        if (name === "espAssembly") updateSummaryCollapse(key);
        else if (name === "gasSeparator") updateGasSeparatorCollapse(key);
    };

    return (
        <>
            <div className='flex flex-col justify-center item-center w-full h-full gap-[16px] text-white'>
                <Accordion
                    title={LABELS?.wellSurvey}
                    id="espAssembly"
                    isOpen={!summaryCollapse}
                    onToggle={() => handleCollapseChange(!summaryCollapse, "espAssembly")}
                    content={
                        <div className="flex justify-center items-center bg-darkcolor-800 p-[16px] w-full rounded-br-lg rounded-bl-lg">
                            <div className='pad-all w-full bg-darkcolor-700 border-[1px] border-darkcolor-400 rounded-lg'>
                                <table className="w-full table table-striped table-bordered dtr-inline">
                                    <colgroup>
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "40%" }} />
                                    </colgroup>
                                    <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                        <th className='col-1 align-center px-[24px] py-[16px] font-normal'>Top of ESP pump (ft)</th>
                                        <td className="col-5 px-[24px] py-[16px]">
                                            <div className="pb-4 secondary"> (BottomOfESPSensor - ESPLength)
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">BottomOfESPSensor :</p>
                                                <p className="secondary-text">
                                                    Bottom of ESP sensor (ft) in ESP assembly input section (Well survey output
                                                    tab)
                                                </p>
                                            </div>
                                            <div className="">
                                                <p className="secondary">ESPLength :</p>
                                                <p className="secondary-text">
                                                    ESP Length (ft) in ESP assembly input section (Well survey output tab)
                                                </p>
                                            </div>
                                        </td>
                                        <th className='col-1 align-center px-[24px] py-[16px] font-normal'>Max DLS above KOP</th>
                                        <td colSpan={3} className="col-5 px-[24px] py-[16px]">
                                            <div className="secondary pb-4">
                                                Select max DLS value above the selected KOP(DLS) list
                                            </div>
                                            <div className="">
                                                <p className="secondary">KOP :</p>
                                                <p className="secondary-text">
                                                    KOP in ESP assembly input section (Well survey output tab)
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                        <th className='col-1 align-center px-[24px] py-[16px] font-normal'>Transition zone (TZ)</th>
                                        <td className="col-5 px-[24px] py-[16px]">
                                            <div className="secondary pb-4">
                                                Select previous MD value from selected KOP(MD) list
                                            </div>
                                            <div className="">
                                                <p className="secondary">KOP :</p>
                                                <p className="secondary-text">
                                                    KOP in ESP assembly input section (Well survey output tab)
                                                </p>
                                            </div>
                                        </td>
                                        <th className='col-1 align-center px-[24px] py-[16px] font-normal'>% Tail Pipe-TZ</th>
                                        <td className="col-5 px-[24px] py-[16px]">
                                            <div className="secondary pb-4">
                                                100 * (TailPipeBttm - TransitionZone) / TailPipe_DesanderL
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">If TailPipe_DesanderL is equal to 0:</p>
                                                <p className="secondary-text">
                                                    % Tail Pipe-TZ = 0
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">If (TailPipeBttm - TransitionZone) is equal to 0:</p>
                                                <p className="secondary-text">
                                                    % Tail Pipe-TZ = 0
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">TailPipeBttm :</p>
                                                <p className="secondary-text">
                                                    Tail Pipe Bttm in ESP assembly input section (Well survey output tab)
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">TransitionZone :</p>
                                                <p className="secondary-text">
                                                    Transition zone in ESP assembly input section (Well survey output tab)
                                                </p>
                                            </div>
                                            <div className="">
                                                <p className="secondary">TailPipe_DesanderL :</p>
                                                <p className="secondary-text">
                                                    Tail Pipe+Desander L in ESP assembly input section (Well survey output tab)
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                        <th className='col-1 align-center px-[24px] py-[16px] font-normal'>Depth of Max DLS (ft)</th>
                                        <td className="col-5 px-[24px] py-[16px]">
                                            <div className="pb-4">
                                                <p className="secondary">Efficiency :</p>
                                                <p className="secondary-text">
                                                    Select MD value corrosponding to MaxDLSAboveKOP value
                                                </p>
                                            </div>
                                            <div className="">
                                                <p className="secondary">MaxDLSAboveKOP :</p>
                                                <p className="secondary-text">
                                                    Max DLS above KOP in ESP assembly input section (Well survey output tab)
                                                </p>
                                            </div>
                                        </td>
                                        <th className='col-1 align-center px-[24px] py-[16px] font-normal'>Tail pipe Bttm</th>
                                        <td colSpan={3} className="col-5 align-center px-[24px] py-[16px]">
                                            <div className="secondary pb-4">
                                                BottomOfESPSensor + TailPipeDesander
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">If TailPipeDesander is equal to 0 :</p>
                                                <p className="secondary-text">
                                                    Tail Pipe Bttm = 0
                                                </p>
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary">BottomOfESPSensor :</p>
                                                <p className="secondary-text">
                                                    BottomOfESPSensor in ESP assembly input section (Well survey output tab)
                                                </p>
                                            </div>
                                            <div className="">
                                                <p className="secondary">TailPipeDesander :</p>
                                                <p className="secondary-text">
                                                    Tail Pipe+Desander L in ESP assembly input section (Well survey output tab)
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="align-center text-[14px] font-normal">
                                        <th className='col-1 align-center px-[24px] py-[16px] font-normal'>Casing size</th>
                                        <td className="col-5 px-[24px] py-[16px]">
                                            <div className="secondary pb-4">
                                                Casing OD & Casing weight
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary"> Casing OD :</p>
                                                <p className="secondary-text">
                                                    Casing OD (Tubing input tab)
                                                </p>
                                            </div>
                                            <div className="">
                                                <p className="secondary"> Casing weight :</p>
                                                <p className="secondary-text">
                                                    Casing weight (Tubing input tab)
                                                </p>
                                            </div>
                                        </td>
                                        <th className='col-1 align-center px-[24px] py-[16px] font-normal'>Tubing size</th>
                                        <td colSpan={3} className="col-5 align-center px-[24px] py-[16px]">
                                            <div className="secondary pb-4">
                                                Tubing OD & Tubing weight
                                            </div>
                                            <div className="pb-4">
                                                <p className="secondary"> Tubing OD :</p>
                                                <p className="secondary-text">
                                                    Tubing OD (Tubing input tab)
                                                </p>
                                            </div>
                                            <div className="">
                                                <p className="secondary"> Tubing weight :</p>
                                                <p className="secondary-text">
                                                    Tubing weight (Tubing input tab)
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    }
                />
            </div>
        </>
    );
};

export default WellSurvey;
